import { extendTheme, withDefaultColorScheme } from '@chakra-ui/react';
import { colorTheme } from './colors';
import { fontSizesTheme, fontTheme, headingTheme } from './typography';
import { checkboxTheme, inputTheme } from './inputs';
import { tabsTheme } from './tabs';
import { menuTheme } from './menu';
import { linkTheme } from './link';
import { badgesTheme } from './badges';
import { buttonTheme } from './button';
import { ThemeTokens } from './tokens';
import { tableTheme } from './table';
import { alertTheme } from './alerts';
import { accordionTheme } from './accordion';
import { textTheme } from './text';

export const theme = extendTheme(
    {
        styles: {
            global: {
                body: {
                    background: ThemeTokens.Defaults.bgColor,
                },
            },
        },
        colors: colorTheme,
        fonts: fontTheme,
        fontSizes: fontSizesTheme,
        components: {
            Alert: alertTheme,
            Accordion: accordionTheme,
            Heading: headingTheme,
            Tabs: tabsTheme,
            Menu: menuTheme,
            Link: linkTheme,
            Input: inputTheme,
            NumberInput: inputTheme,
            Select: inputTheme,
            Radio: inputTheme,
            Textarea: inputTheme,
            Checkbox: checkboxTheme,
            Badge: badgesTheme,
            Button: buttonTheme,
            Table: tableTheme,
            Text: textTheme,
        },
    },
    withDefaultColorScheme({
        colorScheme: 'secondary',
        components: [
            'Button',
            'Tabs',
            'Radio',
            'Switch',
        ],
    })
);
